<div>
    <div class="banner">
        <!-- <div class="value">{{height| number: '1.0-0'}}%</div> -->
        <div class="filler" [style.height.%]="height" [style.background]="color"></div>
    </div>
    <div class="text-center" style="margin-top: 6px; 
    margin-bottom: 6px; 
    font-size: 10px; position: absolute;">
        {{tankValue?.tankName}}
        <br> <b>Gallons: </b>{{tankValue?.lastInventory}}
    </div>
</div>